/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const React = require('react');
const Prism = require('prismjs');
const { withPrefix } = require('gatsby');

const { RootWrapper } = require('./src/components');

require('prismjs/plugins/autoloader/prism-autoloader');
require('prismjs/plugins/toolbar/prism-toolbar');
require('prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard');

Prism.plugins.autoloader.languages_path = withPrefix('/components/');

exports.wrapRootElement = ({ element }, options) => {
  return <RootWrapper>{element}</RootWrapper>;
};
